export const clientStatuses = [
  {
    name: 'client',
    displayName: 'Client',
    disabled: false,
  },
  {
    name: 'potential',
    displayName: 'Potential',
    disabled: false,
  },
  {
    name: 'closed',
    displayName: 'Closed',
    disabled: false,
  },
  {
    name: 'blocked',
    displayName: 'Blocked',
    disabled: false,
  },
  {
    name: 'demo',
    displayName: 'Demo',
    disabled: false,
  },
  {
    name: 'deleted',
    displayName: 'Deleted',
    disabled: false,
  },
  {
    name: 'partially_blocked_billing',
    displayName: 'Partially blocked (payments)',
    disabled: true,
  },
  {
    name: 'blocked_billing',
    displayName: 'Blocked (payments)',
    disabled: true,
  },
  {
    name: 'blocked_overdue',
    displayName: 'Blocked overdue',
    disabled: true,
  },
]
